import { render } from "./UsersEditors.vue?vue&type=template&id=38e5d54e&scoped=true"
import script from "./UsersEditors.vue?vue&type=script&lang=js"
export * from "./UsersEditors.vue?vue&type=script&lang=js"

import "./UsersEditors.vue?vue&type=style&index=0&id=38e5d54e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e5d54e"]])

export default __exports__